import axios from 'axios';
import { action } from 'mobx';
import BaseStore from 'stores/BaseStore';
import config from 'config';
import { merge, startCase } from 'lodash';
import appStore from 'stores/app';

const defaultConfig = {
  types: {
    post: {
      plural: 'posts',
      icon: 'file-alt'
    },
    page: {
      plural: 'sweeps',
      icon: 'ticket-alt'
    },
    page: {
      plural: 'pages',
      icon: 'file'
    }
  }
}

class SettingStore extends BaseStore {
  constructor() {
    super('cms/setting', 'cms/setting');
  }

  @action getThemeConfig = async object => {
    let params = object.split('.') || []

    await this.fetch(this.getCurrentSiteID() || appStore.site.id)

    if (!this.entity.object)
      return { theme_settings: defaultConfig }

    let themeSettings = this.entity.object
    themeSettings.theme_settings = merge({}, defaultConfig, this.entity.object.theme_settings)

    try {
      params.forEach(el => themeSettings = themeSettings[el])
      return themeSettings
    } catch (e) {
      return null
    }
  }

  @action getSystemConfig = (object) => {
    let params = object.split('.') || []

    if (!this.entity.object)
      return { system_config: {} }

    let systemSettings = this.entity.object.system_config

    try {
      params.forEach(el => systemSettings = systemSettings[el])
      return systemSettings
    } catch (e) {
      return null
    }
  }

  getTemplates = (folder = '', defaultOption = [{ value: null, label: 'Default' }]) => async contentType => {
    const extend = templates => defaultOption
      .concat(templates.map(value => ({
        value,
        label: startCase(value)
      })))
    try {
      await this.fetch(this.getCurrentSiteID() || appStore.site.id)
      const { theme = 'default' } = this.entity.object
      const { data: { templates } } = await axios(`${config.cms}/themes/${encodeURIComponent(`${theme}${folder}`)}/${contentType}`)

      const options = extend(templates)

      return { options }
    } catch (err) {
      return { options: extend([]) }
    }
  }
}

export default new SettingStore();
export {
  defaultConfig
};
